<template>
	<b-row v-if="hasPools">
		<b-col>
			<h4 class="mt-3">Point Pools</h4>
			<b-table-simple responsive small bordered striped table-class="mb-0">
				<b-tbody>
					<b-tr v-for="(pool, poolID) in Character.Levels[currentLevel].Pools" :key="'pool-'+poolID">
						<b-td><strong>{{pool.Name}}</strong></b-td>
						<b-td style="max-width: 5em;">
							<span class="mr-0 form-check form-check-inline" v-for="(n,i) in parseInt(pool.MaxPoints||0)" :key="'poolPoint-'+poolID+'-'+i">
								&#9744;
							</span>
						</b-td>
						<b-td class="table-cell-blank"></b-td>
						<b-td class="text-right">{{pool.MaxPoints}}</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-col>
	</b-row>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		...mapGetters([
			'currentLevel',
			'hasPools'
		]),
	}
}
</script>

<style scoped>

</style>